import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HttpService } from '../../services/http.service';
import { ConsentFormComponent } from '../consent-form/consent-form.component';
import { CustomToastComponent } from '../toast/custom-toast.component';

interface ApiDataResponse {
    status: boolean;
    message: string;
    data: {
        status: string; // "APPROVED", "REJECTED", or "ALREADY_APPROVED"
    };
}

@Component({
    selector: 'app-consent-form-page',
    templateUrl: './consent-form-page.component.html',
    styleUrls: ['./consent-form-page.component.scss'],
    imports: [
        ReactiveFormsModule,
        CommonModule,
        FormsModule,
        ConsentFormComponent
    ],
})
export class ParentStudentMediaConsentComponent implements OnInit, OnDestroy {
    private readonly destroy$ = new Subject<void>();

    approvalStatus: boolean | null = null;
    isAlreadyApproved: boolean = false;
    isLoading: boolean = false;
    mediaToken: string = '';

    constructor(
        private httpService: HttpService,
        private snackBar: MatSnackBar,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        // Get the token from query parameters
        this.route.queryParams
            .pipe(takeUntil(this.destroy$))
            .subscribe(params => {
                if (params['token']) {
                    this.mediaToken = params['token'];
                    // console.log('Token extracted from URL:', this.mediaToken);
                } else {
                    this.showErrorToast('No token provided in the URL');
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private showSuccessToast(message: string): void {
        this.showToast(message, 'success-toast');
    }

    private showErrorToast(message: string | null | undefined): void {
        if (!message) return;
        this.showToast(message, 'error-toast');
    }

    private showToast(message: string, panelClass: string): void {
        this.snackBar.openFromComponent(CustomToastComponent, {
            data: { message },
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['no-padding-snackbar', panelClass]
        });
    }
}